package br.com.texeratx.boardgametimeapp.ui.screens.players.model

data class PlayerListItemUI(
    val id: Long,
    val name: String,
    val nickname: String?,
    val imageUrl: String?
)
